import type { RadioProps } from '@/components/RadioGroup';

const drawDayToRadioItemProp = (day: readonly string[]) => {
  return {
    value: day,
    label: {
      text: day,
    },
  };
};

export function mapDrawDaysToRadioGroupItemProps(
  arrayDays: readonly (readonly string[])[]
): readonly RadioProps[] {
  return arrayDays.map(drawDayToRadioItemProp);
}
